module.exports = __webpack_public_path__ + "static/media/jokic.6b2ba5b8.jpg";